const SharedConstants = {
    "AMPLITUDE_PROJECT_CODE": "4c25adc3f55fef801d901bb26a145877",
    "BRANCH_KEY": "key_live_meua0JnjtxXIZCz2tyTJ8npnwzdhTEyp",
    "USER_ID_KEY": "lkjahsdli87z8uhlajsd9zhljashdkj",
    "TIME_TO_END_MATCH": 60
};

export default SharedConstants;
